import { CoinPackagesType } from '@/feature/account-details-sweeps/hooks/use-coin-packages';
import { create } from 'zustand';

import { PaymentMethodTypes } from '../const';

interface DepositStatusState {
    selectedAmount: string;
    retryAmount: string;
    coinPackageId: string;
    paymentProvider: PaymentMethodTypes | string | undefined;
    coinPackage: CoinPackagesType | undefined;
    actions: {
        setDepositStatus: (status: Partial<Omit<DepositStatusState, 'actions'>>) => void;
        clearDepositStatus: () => void;
    };
}

const initialState: Omit<DepositStatusState, 'actions'> = {
    selectedAmount: '',
    retryAmount: '',
    coinPackageId: '',
    paymentProvider: undefined, // TODO: will hook this up
    coinPackage: undefined,
};

/**
 * This store is used to manage the deposit status across different screens
 * TODO: will move paymentProvider, currency, accountID etc into here as well
 */
export const useDepositStatusStore = create<DepositStatusState>()(set => ({
    ...initialState,
    actions: {
        setDepositStatus: statusUpdate => set(state => ({ ...state, ...statusUpdate })),
        clearDepositStatus: () => set(initialState),
    },
}));

export const selectDepositStatus = (state: DepositStatusState) => ({
    selectedAmount: state.selectedAmount,
    paymentProvider: state.paymentProvider,
    coinPackage: state.coinPackage,
    coinPackageId: state.coinPackage?.coin_package_id || '',
});

export const setDepositAmount = (amount: string) => {
    useDepositStatusStore.setState({ selectedAmount: amount });
};

export const setRetryAmount = (amount: string) => {
    useDepositStatusStore.setState({ retryAmount: amount });
};

export const setCoinPackage = (coinPackage: CoinPackagesType) => {
    useDepositStatusStore.setState({
        coinPackage,
        selectedAmount: coinPackage.real_money_price.toString(),
        coinPackageId: coinPackage.coin_package_id.toString(),
    });
};

export const setPaymentProvider = (paymentProvider: PaymentMethodTypes) => {
    useDepositStatusStore.setState({ paymentProvider });
};
